<template>
    <div class="select_wrapper">
        <div class="select">
            <p
                v-waves
                v-for="item in list"
                :key="item.key"
                @click="!disabled ? check(item) : ''"
                :class="{'active':isActive(item),'disabled':disabled}"
                :style="{'box-shadow':isActive(item) ? item.boxShadow : ''}"
            >
                <slot :name="item.key" :item="item">
                    {{item['name' + $lang]}}
                </slot>
            </p>
        </div>
    </div>
</template>
<script>
/**
 * ComponentName: 两个switch的切换
 * Created Date:2022/4/21
 * Author: shishuo·zhang
 * Modify:
 * 组件说明：
 * eg:
 *     <cl-switch-tab :list="list"></cl-switch-tab>
 * list:[{name:'我方',nameEn:'OwnSide',key:'ownSide',color:'#3663E1',boxShadow: '0px 6px 8px rgba(54, 99, 225, 0.3)'}]
 * @selectActive : 点击事件 传出key
 */
export default {
    name: 'cl-switch-tab',
    data () {
        return {
        }
    },
    props: {
        list: { // 切换的tab的列表
            type: Array,
            default: () => []
        },
        active: { // 当前选中的tab
            type: String,
            default: ''
        },
        borderWidth: { // 当前选中的tab
            type: String,
            default: '121px'
        },
        // tabWidth: { // 当前选中的tab
        //     type: String,
        //     default: '50px'
        // },
        disabled:{ // 是否禁止用户点击
            type: Boolean,
            default: false
        }
    },
    methods: {
        isActive (item) {
            return item.key === this.active
        },
        check (item) {
            this.$emit('selectActive', item.key)
        }
    }
}
</script>
<style lang="scss" scoped>
.select_wrapper {
    display: inline-block;
}
.select {
    /*width: 121px;*/
    height: 36px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 5px 8px;
    background: rgba(251, 253, 255, 0.8);
    border: 1px solid #e9edf3;
    border-radius: 4px;
    p {
        height: 26px;
        /*width: 50px;*/
        padding: 3px 11px;
        box-sizing: border-box;
        line-height: 20px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        &.active {
            background:  $base-color-theme;
            color: #fff;
        }
        &.disabled{
            cursor:not-allowed;
        }
    }
}
</style>
